
import BlogHtmlFile from '~/components/Common/Blog/BlogHtmlFile'

export default {
    name: 'Disclosure',
    components: {
        BlogHtmlFile,
    },
}
